<template>
  <div ref="scrollTarget">
    <slot />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const {position} = defineProps(['position'])

const scrollTarget = ref(null)

onMounted(() => {
  scrollTarget.value?.scrollIntoView({ behavior: 'smooth', block: position||'start' })
})
</script>
